import CrudRepository from './CrudRepository'
export default class userNumbersRepository extends CrudRepository {
  constructor () {
    super('core/api/users/numbers/user')
  }
}
